export default {
  error_messages: {
    failed_to_fetch_orders: 'Data kunne ikke indlæses. Klik på ikonet „opdater“ eller prøv igen om 1 minut.',
    something_went_wrong: 'Noget gik galt. Prøv igen.',
  },
};
